import { ExecutionResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { DocumentNode } from 'graphql';

import { GroupModerator, QueryGetModeratorsByGroupArgs } from 'api';

interface IReducer {
  cache: DataProxy;
  result: ExecutionResult;
  query: DocumentNode;
  variables: QueryGetModeratorsByGroupArgs;
  id: string; // TODO: Hack - serve should return deleted ID
}

export default (options: IReducer) => {
  const { cache, query, variables, id } = options;
  const { getModeratorsByGroup } = cache.readQuery({ query, variables });

  if (!getModeratorsByGroup) {
    return;
  }

  const index = getModeratorsByGroup.findIndex(
    (moderator: GroupModerator) => moderator.user_id === id,
  );
  getModeratorsByGroup.splice(index, 1);

  cache.writeQuery({
    query,
    variables,
    data: { getModeratorsByGroup },
  });
};
